import { apiServiceInstance } from '@/core/helpers/utils';
import { extractList } from '@/core/helpers/authorization-utils';
import {
  ApiResponse,
  IApiPermissionItem,
  PaginationResponseBase,
} from '@/core/interfaces/ApiResponses';

export default class PermissionService {
  static list(page = 1, perPage = 300): Promise<{
    data: ApiResponse<PaginationResponseBase<IApiPermissionItem>>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/permissions/danh-sach',
      {
        params: {
          page,
          per_page: perPage,
        },
      }
    );
  }

  /** Fetch every page and return the full permission catalog. */
  static async listAll(): Promise<IApiPermissionItem[]> {
    const all: IApiPermissionItem[] = [];
    let page = 1;
    let lastPage = 1;

    do {
      const { data: body } = await PermissionService.list(page);
      const pagePayload = body.data;
      all.push(...extractList<IApiPermissionItem>(pagePayload));
      lastPage = pagePayload?.last_page ?? 1;
      page += 1;
    } while (page <= lastPage);

    return all;
  }
}
